/*
  const myPath = new BaseTextPath({
    fill: 'black',
    fontSize: 24,
    fontFamily: 'Arial',
    text: 'Initial Text Initial Text Initial Text Initial',
  });

  selectNode(myPath);
  //console.log("myPath", myPath);
  layer.add(myPath);
  layer.draw(); 
*/
class BaseTextPath extends Konva.TextPath {
  constructor(config) {
    super(config);
    
    // Set default attributes
    // this.cornerRadius(config?.cornerRadius ?? 20);

    this.className = 'BaseTextPath';
    this.attrs.type = "basetextpath";

    this.SVGStart = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg"><path id="MyPath" d="';
    this.SVGEnd = '" fill="none" stroke="#f36926" stroke-width="1" /></svg>';

    this.setDraggable(true);

    this.updatePath();
  }

  
  // Getter and Setter for cornerRadius
  /*
  cornerRadius(v) {
    if (v === undefined) return this.attrs.cornerRadius ?? 0;
    this.attrs.cornerRadius = v;
    return this;
  }
  */

  
  static getAttrNames() { return []; }
  static getDefaultAttrs() { return { }; }
  
  /* Get Attributes Examples
  static getAttrNames() { return ['cornerRadius']; }
  static getDefaultAttrs() { return { cornerRadius: 0 }; }
  */


  updatePath() {
    this.setData(this.generateSvgPath());
  };

  /*
  updatePath() {
    this.setData(this.generateSvgPath(this.getAmplitude(), this.getFrequency(), this.getWaves()));
  };
  */


  generateSvgPathn(amplitude, frequency, waves) {
    let str = "";

    return str;
  }

  /*
  generateSvgPathn(amplitude, frequency, waves) {
    // Move To (uppercase = absolute coordinates) ...
    const mv = ([x, y]) => `M ${x} ${y}`;

    // Cubic Bézier (relative coordinates)
    const to = (y, f) => ` c ${f / 2} 0 ${f / 2} ${y} ${f} ${y}`;
    const dn = (y = 10, f = 10) => to(y, f);
    const up = (y = 10, f = 10) => to(-y, f);
    let start = [0, amplitude * 1.5],
        size = [600, amplitude * 2];

    let str = mv(start) + (up(amplitude, frequency) + dn(amplitude, frequency)).repeat(waves);

    return str;
  }
  */


  copySVGDataToClipboard() {
    try {
      navigator.clipboard.writeText(this.SVGStart + this.getData() + this.SVGEnd);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  
}
Konva.BaseTextPath = BaseTextPath;
